import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import TagButton from '../../TagButton';
import { deselectTargets as deselectTargetsAction } from '../../../redux/multiTargetSelection/multiTargetSelectionActions';
import StopIcon from '../../../../../components/icons/StopIcon';

const propTypes = {
  selectedTargets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  deselectTargets: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const SelectedTargetsList = ({
  className,
  deselectTargets,
  selectedTargets = [],
}) => {
  return (
    <div className={className}>
      {selectedTargets.map(target => (
        <TagButton
          key={target.id}
          onClick={() => {
            deselectTargets([target]);
          }}
          name={`${target.name} ${
            target.photoGroup ? `(${target.photoGroup.name})` : ''
          }`}
          className="mr-1 mb-1"
        >
          <StopIcon size="12" className="ml-1" />
        </TagButton>
      ))}
    </div>
  );
};

SelectedTargetsList.propTypes = propTypes;

const mapStateToProps = ({ pro }) => ({
  selectedTargets: pro.multiTargetSelection.selectedTargets,
});

const mapDispatchToProps = {
  deselectTargets: deselectTargetsAction,
};

export { SelectedTargetsList as SelectedTargetsListComponent };

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SelectedTargetsList,
);
